import {Component, Input, OnInit} from '@angular/core';
import {PartNumber} from '@app/shared/models/partNumber.model';
import {PartNumbersService} from "@services/part-numbers.service";
import {Tool} from "@app/tool/model/tool.model";
import {ToolSet} from "@app/tool/model/toolSet.model";
import {Log} from "ng2-logger";

@Component({
    selector: 'app-partnumber-overview',
    templateUrl: './partnumber-overview.component.html',
    styleUrls: ['./partnumber-overview.component.scss']
})
export class PartnumberOverviewComponent implements OnInit {
    _logger = Log.create(PartnumberOverviewComponent.name);

    @Input() mode: string;

    partNumber: PartNumber = new PartNumber();
    affectedTools: any;

    public loading = false;

    constructor(private partNumberService: PartNumbersService) {
    }

    ngOnInit() {
        this.affectedTools = [];
    }

    init(data: PartNumber) {
        Object.assign(this.partNumber, data);
        const toolIds = this.partNumber.tools.map(t => t.id);
        if (this.isEditMode() && this.partNumber.id !== null) {
            this.affectedTools = [];
            this.partNumberService.getAffectedToolsForUpdate(data.id, toolIds).subscribe(
                (tools: any[]) => {
                    tools.forEach(group => {
                        if (group.tools) {
                            this.affectedTools = this.affectedTools.concat(group.tools.map(tool => new Tool(tool)));
                        }
                        if (group.sets) {
                            this.affectedTools = this.affectedTools.concat(group.sets.map(set => new ToolSet(set)));
                        }
                    });
                },
                (error) => {
                    this._logger.error("init::", error);
                }
            )
        }
    }

    private isEditMode() {
        return this.mode === 'edit';
    }
}
